import "../assets/css/loader.css";
function Loader() {
  return <div className="app-spinner"></div>;
}

export default Loader;
